import { Splide } from "@splidejs/splide";
import { getFetch } from "./utilidades/getFetch";
import i18next from "i18next";
import { inicializarInternacionalizacao } from "./localizacao/employer-page/employer-page";
import { localBanner, banner } from './utilidades/banner'

const employer = {
  Splides: {
    splideTabs() {
      const splideOptions = {
        start: 0,
        perPage: 2,
        focus: "start",
        trimSpace: true,
        arrows: false,
        pagination: false,
        autoWidth: true,
        gap: "2rem",
        breakpoints: {
          4000: {
            destroy: true,
          },
          1050: {
            destroy: false,
          },
          980: {
            destroy: true,
          },
          750: {
            destroy: false,
          },
        },
      };

      const splidesTabs = document.getElementById("tabs");
      let splide = new Splide(`#${splidesTabs.id}`, splideOptions);
      splide.mount();
    },
    splideGenerico() {
      const splideOptions = {
        start: 0,
        perPage: 2,
        focus: "start",
        trimSpace: true,
        arrows: true,
        pagination: false,
        autoWidth: true,
        gap: "1rem",
      };
      if (document.contains(document.querySelector(".splide-generico"))) {
        const splidesGen = document.querySelectorAll(".splide-generico");
        splidesGen.forEach((slide) => {
          const splide = new Splide(`#${slide.id}`, splideOptions);
          splide.mount();
        });
      }
    },
    init() {
      this.splideTabs();
      this.splideGenerico();
    },
  },
  async carregarVagas(
    containerResultado,
    empresaID,
    elementoPaginaAtual,
    botaoCarregarMaisVagas,
    resetar = false,
    itensPorPagina = 10
  ) {
    function _templateCardVaga(data) {
      const nomeEmpresa = data.empresa == null ? "" : data.empresa;

      return `
        <li class="list-group-item hover-info d-flex border-0 rounded-1 shadow-sm">
            <div class="container">
                <div class="row">
                    <div class="col-md-1 col-2 px-0  d-flex align-items-top justify-content-center">
                        <div class="pt-1">
                            <div class="img-responsiva vaga-tamanho rounded-1">
                                <img loading=lazy src="${
                                  data.logoThumb
                                }" alt="${nomeEmpresa}" title="${nomeEmpresa}" itemprop="image">
                            </div>
                        </div>
                    </div>

                    <div class="col-md-11 col-10 pt-3 pb-3 px-0 ps-3">
                        <p class="font-size-menor mb-2 nome-da-empresa">${nomeEmpresa}</p>
                        <a href="/${data.url}" class="text-dark stretched-link">
                            ${data.titulo}
                        </a>
                    </div>
                </div>
            </div>
        </li>
        `;
    }

    function _skeletonLoadingCard() {
      let html = "";

      for (let i = 0; i < 5; ++i) {
        html += `
            <li class="card-loading list-group-item d-flex border-0 rounded-1 shadow-sm card-loading-vagas">
                <div class="container">
                    <div class="row">
                        <div class="col-md-1 col-2 px-0  d-flex align-items-top justify-content-center">
                            <div class="pt-1">
                                <div class="img-responsiva vaga-tamanho rounded-1 card-loading-image">
                                </div>
                            </div>
                        </div>

                        <div class="col-md-11 col-10 pt-3 pb-3 px-0 ps-3">
                            <p class="card-loading-bar mb-2" style="width: 60px"></p>
                            <p class="card-loading-bar"></p>
                        </div>
                    </div>
                </div>
            </li>
            `;
      }
      return html;
    }

    function _ocultarBotoesCarregarMaisVagas() {
      botaoCarregarMaisVagas.forEach((el) => {
        if (!el.classList.contains("d-none")) {
          el.classList.add("d-none");
        }
        return;
      });
    }

    // Sem a empresa desta pagina nao da para buscar: a API sem empresaID cai na busca geral do site
    // e devolveria vaga de terceiro. O input pode faltar na janela pos-deploy (HTML da fanpage tem
    // Cache-Control public de 10min e o ?v= do bundle nao e atomico: HTML velho + JS novo).
    if (!empresaID) {
      containerResultado.forEach((el) => (el.innerHTML = ""));
      _ocultarBotoesCarregarMaisVagas();
      return;
    }

    if (resetar) {
      containerResultado.forEach(
        (el) => (el.innerHTML = _skeletonLoadingCard())
      );
      elementoPaginaAtual.value = 1;
    }

    const urlBase = URL_API + "vagas/buscar-novo";
    const urlCompleta = new URLSearchParams();
    urlCompleta.append("culture", CULTURE_EMPREGARE);
    urlCompleta.append("pagina", elementoPaginaAtual.value);
    urlCompleta.append("itensPagina", itensPorPagina);
    urlCompleta.append("empresaID", empresaID);

    containerResultado.forEach(
      (el) => (el.innerHTML += _skeletonLoadingCard())
    );

    await getFetch(urlBase + "?" + urlCompleta.toString(), (resultado) => {
      inicializarInternacionalizacao()
      let conteudoVagas = "";

      const paginaAtual = resultado.model.pagina;
      const totalPaginas = resultado.model.totalPaginas;
      if (resultado.model.dados.length == 0) {
        conteudoVagas = `
                <div class="alert alert-info">
                    <div class="d-flex w-100 gap-2 flex-row justify-content-center align-items-center h-100">
                        <span>${i18next.t('ListagemVagasNenhumaVaga')}</span>
                    </div>
                </div>
            `;

        _ocultarBotoesCarregarMaisVagas();
      } else {
        if (paginaAtual >= totalPaginas) {
          _ocultarBotoesCarregarMaisVagas();
        }

        if (paginaAtual > 1) {
          // conteudoVagas += `<p class="my-3 mx-3 mx-md-0">Página <b>${paginaAtual}</b> com <b>${
          //   totalPaginas - paginaAtual
          // }</b> páginas restantes</p>`;

          conteudoVagas += `<p class="my-3 mx-3 mx-md-0">${i18next.t('ListagemVagasPaginasRestantes', { paginaAtual: paginaAtual, paginasRestantes: totalPaginas - paginaAtual })}</p>`;
        }

        for (let i = 0; i < resultado.model.dados.length; ++i) {
          conteudoVagas += _templateCardVaga(resultado.model.dados[i]);
        }
      }

      containerResultado.forEach((el) => (el.innerHTML += conteudoVagas));
    });

    //Atualiza valor do hidden para que na próxima chamada busque por uma nova página
    elementoPaginaAtual.value = parseInt(elementoPaginaAtual.value) + 1;

    //Remove os skeletons loadings
    document
      .querySelectorAll(".card-loading-vagas")
      .forEach((el) => el.remove());
  },
  addEstiloAtivo() {
    var navTabs = document.querySelector(".nav-tabs");
    var btns = document.querySelectorAll(".nav-link");

    navTabs.addEventListener("click", function (e) {
      if (e.target.classList.contains("nav-link")) {
        btns.forEach((btn) => {
          btn.classList.remove("active");
          btn.classList.remove("link-menu-ativo");
        });
        e.target.classList.add("active");
        e.target.classList.add("link-menu-ativo");
      }
    });
  },
  trocaArrowAtivo() {
    if (document.contains(document.querySelector(".splide-generico"))) {
      //O plugin do splide adiciona o disabled e a func se baseia nisso
      var arrowFields = document.querySelectorAll(".splide__arrow");
      var observer = new MutationObserver(function (mutations) {
        for (var i = 0, mutation; (mutation = mutations[i]); i++) {
          if (mutation.attributeName == "disabled") {
            if (mutation.target.disabled) {
              mutation.target
                .querySelector(".arrow-container-able")
                .classList.add("d-none");
              mutation.target
                .querySelector(".arrow-container-disable")
                .classList.remove("d-none");
            } else {
              mutation.target
                .querySelector(".arrow-container-able")
                .classList.remove("d-none");
              mutation.target
                .querySelector(".arrow-container-disable")
                .classList.add("d-none");
            }
          }
        }
      });
      arrowFields.forEach((field) => {
        observer.observe(field, { attributes: true });
        field.disabled = false;
        if (field.classList.contains("splide__arrow--prev"))
          field.disabled = true;
      });
    }
  },

  showNavStickerTop() {
    const headers = document.querySelectorAll("header");
    const navSticker = document.getElementById("nav-sticker");
    const navBtns = document.querySelectorAll(".nav-link");
    const target = document.getElementById("row-tab");
    const bordaSuperior = document.getElementById("elemento-borda-superior");
    const containerMenuLateral = document.querySelector(".container-side-bar-candidato");

    const stickyNavFunc = function (entries) {
      const [entry] = entries;

      // So deixa o "header" aparecer se passar abaixo do observerMa por isso do y negativo
      if (!entry.isIntersecting && entry.boundingClientRect.y < 0) {
        navSticker.classList.add("tab-fixed-top");
        headers.forEach((header) => {
          header.classList.add("shadow-none");
        });
        bordaSuperior.parentElement.classList.add("px-sm-4");
        bordaSuperior.classList.remove("borda-superior");
        navBtns.forEach((btn) => {
          btn.setAttribute(
            "onclick",
            "window.location.href ='#btn-vizualizar-vagas';"
          );
        });

      } else {
        navSticker.classList.remove("tab-fixed-top");
        headers.forEach((header) => {
          header.classList.remove("shadow-none");
        });
        bordaSuperior.parentElement.classList.remove("px-sm-4");
        bordaSuperior.classList.add("borda-superior");
        navBtns.forEach((btn) => {
          btn.removeAttribute("onclick");
        });
      }
    };
    const navStickerObeserver = new IntersectionObserver(stickyNavFunc, {
      root: null,
      threshold: 0.05,
    });

    navStickerObeserver.observe(target);
  },
  TabClick() {
    const btnsSobre = document.querySelectorAll(".abrir-sobre");
    const btnsVagas = document.querySelectorAll(".abrir-vagas");
    const tabSobre = document.getElementById("sobre-tab");
    const tabVagas = document.getElementById("vagas-tab");
    btnsSobre.forEach((btn) =>
      btn.addEventListener("click", () => tabSobre.click())
    );
    btnsVagas.forEach((btn) =>
      btn.addEventListener("click", () => tabVagas.click())
    );

    tabVagas.addEventListener("click", async (e) => {
      await this.carregarVagas(
        document.querySelectorAll(".listagem-vagas"),
        document.getElementById("employerPageEmpresaID")?.value,
        document.getElementById("VagasPaginaAtual"),
        document.querySelectorAll(".btn-carregar-mais-vagas"),
        true,
        5
      );
    });
  },
  async LighBox() {
    if (document.contains(document.getElementById("galeria-tab-pane"))) {
      const { default: SimpleLightbox } = await import("simplelightbox");
      let lightbox = new SimpleLightbox(".galeria-imagens a");
    }
  },
  // Descricao da empresa recolhida: o texto vai inteiro para o HTML e o CSS esconde o excesso.
  // O botao so entra em cena quando ha o que revelar — antes ele aparecia mesmo para uma empresa
  // que escreveu duas frases, e clicar nao mudava nada.
  ConteudoRecolhivel() {
    document.querySelectorAll("[data-conteudo-recolhivel]").forEach((bloco) => {
      const caixa = bloco.closest(".conteudo-recolhivel-caixa");
      const botao = caixa && caixa.querySelector(".btn-recolhivel");
      if (!botao) return;

      // 2px de folga: arredondamento de linha ja fez scrollHeight passar clientHeight por 1px
      if (bloco.scrollHeight <= bloco.clientHeight + 2) return;

      botao.hidden = false;
      botao.setAttribute("aria-expanded", "false");

      botao.addEventListener("click", () => {
        // o estado vive na caixa: ela manda no teto do texto, na faixa e no lugar do botao
        const expandir = !caixa.classList.contains("esta-expandido");

        // A transicao precisa de um alvo em px: max-height "none" nao anima. Ao expandir, sobe de
        // 9.5em ate a altura do conteudo; ao recolher, ancora a altura atual antes de devolver o
        // teto ao CSS (o reflow forcado e o que faz o navegador enxergar o ponto de partida).
        bloco.style.maxHeight = `${bloco.scrollHeight}px`;

        if (expandir) {
          caixa.classList.add("esta-expandido");

          // solta a altura no fim: assim o bloco acompanha resize e mudanca de fonte
          bloco.addEventListener("transitionend", function soltar(evento) {
            if (evento.propertyName !== "max-height") return;

            bloco.style.maxHeight = "";
            bloco.removeEventListener("transitionend", soltar);
          });
        } else {
          void bloco.offsetHeight;
          caixa.classList.remove("esta-expandido");
          bloco.style.maxHeight = "";
        }

        botao.setAttribute("aria-expanded", String(expandir));

        const rotulo = expandir ? botao.dataset.rotuloMenos : botao.dataset.rotuloMais;
        const seta = expandir ? "bi-chevron-up" : "bi-chevron-down";
        botao.innerHTML = `${rotulo} <i class="bi ${seta}"></i>`;
      });
    });
  },
  init() {
    banner.renderizar('banner-employer-page', localBanner.EMPLOYER_PAGE);
    banner.renderizar('banner-employer-page-mobile', localBanner.EMPLOYER_PAGE);

    this.showNavStickerTop();
    this.Splides.init();
    this.addEstiloAtivo();
    this.trocaArrowAtivo();
    this.TabClick();
    this.ConteudoRecolhivel();
    this.LighBox();

    document.querySelectorAll(".btn-carregar-mais-vagas").forEach((el) =>
      el.addEventListener("click", async () => {
        await this.carregarVagas(
          document.querySelectorAll(".listagem-vagas"),
          document.getElementById("employerPageEmpresaID")?.value,
          document.getElementById("VagasPaginaAtual"),
          document.querySelectorAll(".btn-carregar-mais-vagas"),
          false,
          5
        );
      })
    );

    (async () => {
      await this.carregarVagas(
        document.querySelectorAll(".listagem-vagas"),
        document.getElementById("employerPageEmpresaID")?.value,
        document.getElementById("VagasPaginaAtual"),
        document.querySelectorAll(".btn-carregar-mais-vagas"),
        false,
        5
      );
    })();
  },
};
employer.init();
